import axios from "axios";
import router from "@/router";

const service = axios.create({
  // baseURL: process.env.VUE_APP_URL,
  baseURL: "/wctapi",
  timeout: 15000,
});

service.interceptors.request.use(
  (config) => {
    if (config.method === "get") {
      config.params = {
        // _t: Date.parse(new Date()) / 1000,
        ...config.params,
      };
    }
    return config;
  },
  (error) => Promise.reject(error),
);

service.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data?.code == 40201) {
      // OAuth 路由体系由页面自行处理未登录跳转（/oauth/login），不走主站登录页
      if (router.currentRoute.path.startsWith("/oauth")) {
        return Promise.resolve(data);
      }
      // 请求方声明自行处理未登录（如优惠券领取页的登录弹窗），不做全局跳转
      if (response.config && response.config.skipAuthRedirect) {
        return Promise.resolve(data);
      }
      // 如果当前路由不是 login，才跳转到登录页面
      if (router.currentRoute.path !== "/login") {
        let query = {};
        if (window.sessionStorage.getItem("reg")) {
          query.reg = window.sessionStorage.getItem("reg");
        }
        // 带上当前页完整地址（含 hash 路由与查询参数），登录成功后原路回跳
        if (!query.redirect) {
          query.redirect = window.location.href;
        }
        router
          .push({
            path: "/login",
            query: query,
          })
          .catch(() => {})
          .finally(() => {
            window.sessionStorage.removeItem("reg");
          });
      }
    }
    return Promise.resolve(data);
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default service;
